import PlatformDefaults from "../Entity/PlatformDefaults";
import CrudApi from "@serie3/common/api/crudApi";
import SocialEndpoints from "../endpoints";

const createPlatformDefaultsForm = () => {
  const onSubmit = async (values) => {
    await CrudApi.edit(SocialEndpoints.settings.platformDefaults, JSON.stringify(values, null, 2));
  };

  return {
    initialValues: PlatformDefaults,
    onSubmit: (values) => {
      onSubmit(values);
    },
  };
};

const createPostPlatformSettingsForm = (postId) => {
  const onSubmit = async (values) => {
    await CrudApi.edit(
      SocialEndpoints.posts.platformSettings + postId + "/platform-settings",
      JSON.stringify(values, null, 2)
    );
  };

  return {
    initialValues: PlatformDefaults,
    onSubmit: (values) => {
      onSubmit(values);
    },
  };
};

const setEditData = (data) => {
  const base = { ...PlatformDefaults };
  // Older backends answered with the stored JSON *string*; accept both shapes.
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      data = {};
    }
  }
  data = data && typeof data === "object" ? data : {};

  const merge = (target, source) => {
    if (!source) return target;
    const result = { ...target };
    for (const key of Object.keys(target)) {
      if (source[key] !== undefined) {
        if (typeof target[key] === "object" && target[key] !== null && !Array.isArray(target[key])) {
          result[key] = merge(target[key], source[key]);
        } else {
          result[key] = source[key];
        }
      }
    }
    return result;
  };

  return {
    youtube:  merge(base.youtube,  data.youtube),
    meta:     merge(base.meta,     data.meta),
    tiktok:   merge(base.tiktok,   data.tiktok),
    linkedin: merge(base.linkedin, data.linkedin),
    x:        merge(base.x,        data.x),
  };
};

export default { createPlatformDefaultsForm, createPostPlatformSettingsForm, setEditData };
